module.exports = __webpack_public_path__ + "mainassets/img/faq-1-a.8afa309b.svg";